import React, { useEffect, useState } from "react";
import authQueries from '../../../queries/authQueries';
import { Link, useNavigate } from "react-router-dom";

const Branchtarget =()=>{

    const [result, setResult] = useState([]);
    const [status, setStatus] = useState('');
    const [fromDate, setfromDate] = useState('2022-04-01');
    const [toDate, settoDate] = useState('2023-03-31');


    useEffect(()=>{
        const today = new Date();
        const financialYears = calculateFinancialYears(today);
        branchTargeteApi.mutateAsync({from: financialYears.from, to:financialYears.to, page:0, size:10});
    },[]);

    
    function calculateFinancialYears(date) {
        const today = date || new Date();
        const currentYear = today.getFullYear();
        const from = `${currentYear}-04-01`;
        const to = `${currentYear + 1}-03-31`;
        return {
            from,
            to
        };
      }

    const branchTargeteApi = authQueries.useBranchTargeteReport(

        (response) => {
            console.log("response",response)
            setResult(response);        
        }   
    
    );

    const handlefromDate = (event) => {
        const value = event.target.value;
        console.log("fromdate",value)
        setfromDate(value);
    };

    const handletoDate = (event) => {
        const value = event.target.value;
        console.log("todate",value)
        settoDate(value);
    };

    const filterData = (e) => {
        branchTargeteApi.mutateAsync({ from: fromDate, to:toDate, page:0, size:10  });
        setStatus(e.target.value)
      }


    return(
        <div>
            <div className="content-area">
				<div className="breadcrumb-and-otherbuttons">
					{/* <!-- breadcrumb --> */}
					<nav aria-label="breadcrumb">
					  <ol className="breadcrumb">
						<li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
						<li className="breadcrumb-item active" aria-current="page">Branch Wise Registration Target Report</li>
					  </ol>
					</nav>
				</div>
				
				{/* <!-- addclients --> */}
				<div className="add_clients">
				
					<div className="row">
                        <div className="col-md-6 appointments-hing-wrpr">
                            <i className="appointments-icon">
                                <img src={require("../../../assets/images/appointments-today-icon.png")} width="" height="" alt="" />
                            </i>
                            <h2><span>&nbsp;</span>Branch Wise Registration Target Report</h2>	
                        </div>
							
                        <div className="col-md-12">
                            <hr className="progress-hr" />
                        </div>
					</div>
					

					<div id="accordion" className="add_clients_accordion_form">
						<div className="card" id="appointments_wrpr">
						  <div className="card-header">
							
                          Branch Wise Registration Target Report
							
							
						  </div>
						  <div id="appointment_any" className="collapse show" data-parent="#accordion">
							<div className="card-body">
									
                                <div className="row ">
                                    <div className="col-md-12">
                                    
                                        <div className="table-list-search-wrpr">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    
                                                </div>
                                                <div className="col-md-6 text-right">
                                                <div className="table-search-filter-wrpr">
                                                   <div style={{display: "-webkit-inline-box" }} className="table-search-wrpr">
                                                      <label style={{marginRight:7}}>From</label>
                                                      <input style={{minWidth: '100px'}} value={fromDate} onChange={handlefromDate}  className="form-control form-control-sm" type="date" placeholder="From" />
                                                      <label style={{marginRight:7}}>To</label>
                                                      <input style={{minWidth: '100px'}} value={toDate} onChange={handletoDate}  className="form-control form-control-sm" type="date" placeholder="TO" />
                                                      <button style={{background: '#323a51'}} onClick={filterData} className="btn btn-info">Search</button>
                                                    </div>
                                                </div>
                                                </div>
                                        </div>

                                        
                                        
                                            <table border={1} className="table report collageprogram">
                                                <thead>
                                                    <tr>
                                      
                                                    <th >Office</th>
                                                    <th width="200">Visa Approved Files</th>
                                                    <th width="200">Registration Target</th>
                                                    </tr>
                                                </thead>
                                                <tbody  className="ui-sortable">
                                                { branchTargeteApi.isLoading && "Loading" }
                                                {   
                                                    branchTargeteApi?.data?.data[0]?.map((item, index) =>
                                                    {  

                                                    return(
                                                        <tr className="ui-sortable-handle">
                     
                                                        <td>{item.name }</td>
                                                        <td>{item.visa_approved}</td>
                                                        <td>{item.target}</td>
                                                        </tr>
                                                    )})
                                                }
                                               </tbody>

                                            </table>
                                    </div>
                                </div>
								
								</div>
							</div>
						</div>
						
						
					  </div>
					
				</div>
				
			</div>

        </div>

    </div>
    )

    


    
}
export default Branchtarget;